/**
 * データエクスポート・PDF生成のバージョン定数
 *
 * このバージョンは以下の用途で使用されます：
 * - データエクスポート（JSON）のスキーマバージョン
 * - データインポート時のバージョン検証
 * - 履歴書PDF生成リクエスト
 * - 経歴書PDF生成リクエスト
 *
 * ## 重要な運用ルール
 *
 * **このバージョン番号は必ずGitHubのリリースタグと一致させてください。**
 *
 * - 形式: `v{major}.{minor}.{patch}` (例: v0.0.1, v1.0.0)
 * - 更新タイミング: 新しいリリースタグを作成する際に同時に更新
 *
 * ## バージョン更新手順
 *
 * 1. この定数の値を新しいバージョンに更新
 * 2. 変更をコミット・プッシュ
 * 3. GitHubで対応するリリースタグを作成
 * 4. リリースノートに変更内容を記載
 *
 * @example
 * ```typescript
 * // v1.0.0 へのバージョンアップ例
 * export const DATA_EXPORT_VERSION = 'v1.0.0';
 * ```
 *
 * @see README.md の「バージョン管理」セクションを参照
 */
export const DATA_EXPORT_VERSION = 'v0.0.1';
